import './script-editor-page.css';
import { useEffect, useState } from 'react';
import { Button, notification } from 'antd';
import { highlight, languages } from 'prismjs';
import Editor from 'react-simple-code-editor';
import 'prismjs/components/prism-clike';
import 'prismjs/components/prism-javascript';
import 'prismjs/themes/prism.css';

import { addControlStyle } from './script-editor-page-style';
import { useParams } from 'react-router-dom';

import { useLazyGetTransformerScriptQuery, useCreateTransformerScriptMutation, useUpdateTransformerScriptMutation } from '../../redux/api/transformers';
import { ScriptTestModal } from './script-test-modal';

const ScriptEditorPage = () => {

    const [ id, setId ] = useState<number | undefined>();
    const [ code, setCode ] = useState<string>('');
    const [ editing, setEditing ] = useState<boolean>(false);
    const [ isTestOpen, setTestOpen ] = useState<boolean>(false);
    const [ tableHeight, setTableHeight ] = useState<number>();
    
    const { clientId } = useParams();

    const [getScript] = useLazyGetTransformerScriptQuery();
    const [createScript] = useCreateTransformerScriptMutation();
    const [updateScript] = useUpdateTransformerScriptMutation();
    
    const updateTableHeight = () => {
        const windowHeight = window.innerHeight; // Full screen height
        const calculatedHeight = windowHeight - 168; // Subtract paddings and headers
        setTableHeight(calculatedHeight);
    };
      
    useEffect(() => {
        fetchScript();
        updateTableHeight(); // Set height on mount
        window.addEventListener("resize", updateTableHeight); // Adjust height on resize
        return () => window.removeEventListener("resize", updateTableHeight);
    }, []);


    const fetchScript = async () => {

        try {
            const response = await getScript(clientId).unwrap();
            setId(response.id);
            setCode(response.script);
        } catch (e) {
        }
    }

    const onEdit = (code: string) => {
        setEditing(true);
        setCode(code);
    }

    const onTest = () => {
        setTestOpen(true);
    }

    /**
     * Adds a user by sending the user data to the server.
     * 
     * @param user the user to add
     */
    const onSave = async (): Promise<void> => {

        try {

            const payload = {
                clientId,
                script: code
            }

            const response = id ? await updateScript({id, payload}).unwrap() : createScript(payload).unwrap();
            setId(response.id);
            setCode(response.script);
            setEditing(false);

        } catch (e) {
            console.log(e);
            notification.error({
                message: "Creating Script Failed!",
                description: `An error occurred while saving the script`
            });
        }
    }

    return <>
        <div style={addControlStyle}>
            <h1>Transformer Script</h1>
            <div className="controls">
            <Button
                type="primary"
                onClick={onTest}>
                Test Script
            </Button>
            <Button
                type="primary"
                disabled={!editing}
                onClick={onSave}>
                Save Script
            </Button>
            </div>
        </div>
        <div className="editor" style={{height: tableHeight}}>
            <Editor
                value={code}
                onValueChange={code => onEdit(code)}
                highlight={(code) => highlight(code, languages.js!, 'js')}
                padding={10}
                style={{
                    minHeight: tableHeight,
                    background: 'white',
                    border: 'none',
                    fontFamily: '"Fira code", "Fira Mono", monospace',
                    fontSize: 14,
                }}
            />
        </div>

        <ScriptTestModal
            clientId={parseInt(clientId!)}
            open={isTestOpen}
            onCancel={() => setTestOpen(false)}/>
    </>
};

export default ScriptEditorPage;

